import React from 'react';
import { Check, X } from 'react-bootstrap-icons';

const CheckOrX: FC<{ value: boolean }> = ({ value }) => {
  return value ? <Check /> : <X />;
};

export default CheckOrX;
